import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { App } from './App';
import reportWebVitals from './reportWebVitals';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import appTheme from './theme/appTheme';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <ThemeProvider theme={appTheme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  // </React.StrictMode>
);

reportWebVitals();
